import React from 'react';
import { ChakraV3 } from '..';

export interface CheckboxStackOption {
  value: string;
  label: string;
  description?: string | React.ReactElement;
  icon?: React.ReactElement;
  extraContent?: React.ReactElement;
  isDisabled?: boolean;
}

export interface CheckboxStackProps
  extends Omit<ChakraV3.CheckboxGroupProps, 'onChange' | 'value'> {
  options: CheckboxStackOption[];
  value: string[];
  onChange: (value: string[]) => void;
}

export const CheckboxStack = (props: CheckboxStackProps) => {
  const { options, value, onChange, ...rest } = props;

  return (
    <ChakraV3.CheckboxGroup value={value} onValueChange={onChange} colorPalette='brand' {...rest}>
      <ChakraV3.Stack gap='2'>
        {options.map((option) => (
          <ChakraV3.CheckboxCard.Root
            key={option.value}
            value={option.value}
            disabled={option.isDisabled}
            variant='outline'
            colorPalette='brand'
          >
            <ChakraV3.CheckboxCard.HiddenInput />
            <ChakraV3.CheckboxCard.Control
              alignItems='center'
              gap={4}
              data-pw={`${option.label}-checkbox`}
            >
              <ChakraV3.CheckboxCard.Indicator />
              {option.icon && <ChakraV3.Icon size='md'>{option.icon}</ChakraV3.Icon>}
              <ChakraV3.CheckboxCard.Content>
                <ChakraV3.CheckboxCard.Label w='full'>{option.label}</ChakraV3.CheckboxCard.Label>
                {option.description && (
                  <ChakraV3.CheckboxCard.Description w='full'>
                    {option.description}
                  </ChakraV3.CheckboxCard.Description>
                )}
              </ChakraV3.CheckboxCard.Content>
            </ChakraV3.CheckboxCard.Control>
          </ChakraV3.CheckboxCard.Root>
        ))}
      </ChakraV3.Stack>
    </ChakraV3.CheckboxGroup>
  );
};
